import { useSelector } from "react-redux";
import { useMemo } from "react";
import { formattedPlayerName } from "../Utils/name_utils";

const getPlayerInitials = (firstName, lastName) => {
	if (!firstName || !lastName) return "";
	return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};

export const usePlayerData = () => {
	const {
		filter: { player },
	} = useSelector(({ player }) => player);
	const {
		info: { display_name: teamName, team_logo, id },
		players,
	} = useSelector(({ team }) => team);

	const playerObject = useMemo(
		() => players.find((p) => p.player_id === player),
		[players, player]
	);

	const playerName = useMemo(
		() =>
			playerObject && teamName
				? formattedPlayerName(
						teamName,
						`${playerObject.first_name} ${playerObject.last_name}`
				  )
				: "",
		[playerObject, teamName]
	);

	const playerInitials = useMemo(
		() =>
			getPlayerInitials(
				playerObject?.first_name,
				playerObject?.last_name
			),
		[playerObject?.first_name, playerObject?.last_name]
	);
	return {
		player,
		teamName,
		team_logo,
		id,
		playerObject,
		playerName,
		playerInitials,
		headshot: playerObject?.headshot,
		useOverlay: playerObject?.use_overlayed_headshot,
	};
};
